import React from "react";

function AboutComp(props) {
  return (
    <div className="p-4 flex-col items-center text-black md:px-14 md:py-6">
      <div dangerouslySetInnerHTML={{ __html: props.content }}></div>
    </div>
  );
}
export default AboutComp;
